import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import useNavigationPaneStore from '../../store/navigationPaneStore/useNavigationPaneStore';
import useUserStore from '../../store/userStore/useUserStore';
import { locator } from '../../testing/e2e-locator/locator';

export const NavigationPane = ({
  withDrawer,
  withUserNameHeader,
}: {
  withDrawer?: boolean;
  withUserNameHeader?: boolean;
}): ReactNode => {
  const { drawerOpen, setDrawerOpen } = useNavigationPaneStore();

  const {
    computed: { userTruncatedName },
  } = useUserStore();

  const { t } = useTranslation();

  const location = useLocation();

  // const isRefandiFeaturesEnabled = useFeatureFlag(
  //   FeatureFlag.ENABLE_REFANDI_HIDDEN_FEATURES,
  // );

  const garageItemSelected = useMemo((): boolean => {
    const selectedPaths = ['/dashboard/garage', '/dashboard/application'];

    return selectedPaths.some((path): boolean =>
      location.pathname.includes(path),
    );
  }, [location]);

  const WithDrawer = ({ children }: { children: ReactNode }): ReactNode =>
    withDrawer ? (
      <Drawer
        anchor={'right'}
        open={drawerOpen}
        onClose={(): void => {
          setDrawerOpen(false);
        }}
      >
        {children}
      </Drawer>
    ) : (
      children
    );

  return (
    <CssBaseline>
      <WithDrawer>
        <div
          className="navigation-pane"
          data-testid={locator.components.navigationPane.root}
        >
          <List disablePadding>
            {withUserNameHeader && (
              <ListItem disablePadding>
                <ListItemText
                  primary={userTruncatedName}
                  primaryTypographyProps={
                    {
                      'data-testid': locator.components.navigationPane.userName,
                    } as unknown
                  }
                />
              </ListItem>
            )}

            {withUserNameHeader && <Divider />}

            <ListItem disablePadding>
              <ListItemButton
                component={Link}
                data-testid={locator.components.navigationPane.garageLink}
                selected={garageItemSelected}
                to={'/dashboard/garage'}
                onClick={(): void => {
                  setDrawerOpen(false);
                }}
              >
                <ListItemIcon>
                  <HomeOutlinedIcon />
                </ListItemIcon>
                <ListItemText secondary={t('navigation.garage')} />
              </ListItemButton>
            </ListItem>

            {/* {isRefandiFeaturesEnabled && (
              <ListItem disablePadding>
                <ListItemButton
                  component={Link}
                  to={'/dashboard/account'}
                  onClick={() => setDrawerOpen(false)}
                >
                  <ListItemIcon>
                    <AccountCircleOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText secondary={t('navigation.account')} />
                </ListItemButton>
              </ListItem>
            )} */}

            <ListItem disablePadding>
              <ListItemButton
                component={Link}
                data-testid={locator.components.navigationPane.signOutLink}
                to={'/sign-out'}
                onClick={(): void => {
                  setDrawerOpen(false);
                }}
              >
                <ListItemIcon>
                  <ExitToAppOutlinedIcon />
                </ListItemIcon>
                <ListItemText secondary={t('navigation.signout')} />
              </ListItemButton>
            </ListItem>
          </List>
        </div>
      </WithDrawer>
    </CssBaseline>
  );
};
